import type { ComponentType } from "react";
import { AccessRequestsToolUI } from "./AccessRequestsCard";
import { CohortCreatedToolUI, CohortUpdatedToolUI } from "./CohortSummaryCard";
import type { ToolUIProps } from "./ToolUIContext";

// The cohort itself renders in the MCP Apps side pane (cohort-app.html, see
// PANE_MCP_SERVER_IDS in useMcpAppsPane.tsx). Create and update also get an
// inline summary card here that opens it.
export const TOOL_UI_REGISTRY: Map<string, ComponentType<ToolUIProps>> = new Map([
  ["cohort_explorer_get_access_requests", AccessRequestsToolUI],
  ["cohort_explorer_create_cohort", CohortCreatedToolUI],
  ["cohort_explorer_update_cohort", CohortUpdatedToolUI],
]);
